import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import applicationMap from "services/applicationMap";

import { IApplicationState } from "store/index";
import { IPopup, PopupType } from "store/ui/ui.types";

import ErrorPopup, {
  IErrorPopupDynamicProps,
} from "components/Popups/ErrorPopup/ErrorPopup";

const Popups = () => {
  const history = useHistory();

  const popup: IPopup | null = useSelector(
    (state: IApplicationState) => state.ui.popup,
    shallowEqual
  );

  if (!popup) {
    return null;
  }

  const handleHidePopup = () => {
    history.push(applicationMap.routes.index());
    popup.data?.hidePopup();
  };

  const data = popup.data || {};

  switch (popup.type) {
    case PopupType.ErrorPopup:
      return (
        <ErrorPopup
          {...(data as IErrorPopupDynamicProps)}
          hidePopup={handleHidePopup}
        />
      );
    default:
      return null;
  }
};

export default Popups;
